import { combineReducers, configureStore } from "@reduxjs/toolkit";

import alertReducer from "./features/alert/alertSlice";
import authReducer from "./features/auth/authSlice";
import clubhouseReducer from "./features/clubhouse/clubhouseSlice";
import globalReducer from "./features/global/globalSlice";
import leagueManagementReducer from "./features/leaguemgmt/leagueManagementSlice";
import userReducer from "./features/user/userSlice";

const rootReducer = combineReducers({
    auth: authReducer,
    alert: alertReducer,
    clubhouse: clubhouseReducer,
    global: globalReducer,
    user: userReducer,
    leaguemanagement: leagueManagementReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
    });
};

export const setupTestStore = (preloadedState?: Partial<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware({
                immutableCheck: false,
                serializableCheck: {},
            }),
    });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
